import { render, staticRenderFns } from "./ActionLoadSettings.vue?vue&type=template&id=c4c600e0&"
import script from "./ActionLoadSettings.vue?vue&type=script&lang=js&"
export * from "./ActionLoadSettings.vue?vue&type=script&lang=js&"
import style0 from "./ActionLoadSettings.vue?vue&type=style&index=0&id=c4c600e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports